<div class="transaction-details-container">
  <div class="header">
    <span *ngIf="!showAddForm">
      Share product feedback with the Aisslo team. Review your past submissions and help us improve the platform.
    </span>
    <span *ngIf="showAddForm">
      Tell us what is working well and what we can improve. Your feedback helps shape the product roadmap.
    </span>

    <div class="actions">
      <button
        *ngIf="!showAddForm"
        type="button"
        class="filter-button"
        (click)="openAddForm()"
      >
        <i class="fa-solid fa-plus" style="margin-right: 8px;"></i>
        <span>Add New</span>
      </button>

      <button
        *ngIf="showAddForm"
        type="button"
        class="filter-button secondary-button"
        (click)="cancelAddForm()"
      >
        <i class="fa-solid fa-arrow-left" style="margin-right: 8px;"></i>
        <span>Back to List</span>
      </button>
    </div>
  </div>

  <div *ngIf="!showAddForm" class="table-container">
    <div *ngIf="isLoading" class="no-transactions-message">Loading feedback...</div>

    <table *ngIf="!isLoading" class="transactions-table">
      <thead>
        <tr>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-calendar-days th-icon"></i>
              <span>Date</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-comment-dots th-icon"></i>
              <span>Feedback</span>
            </div>
          </th>
          <th>
            <div class="th-content">
              <i class="fa-solid fa-user th-icon"></i>
              <span>Submitted By</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="feedbackList.length > 0; else noFeedback">
          <tr *ngFor="let feedback of feedbackList">
            <td style="opacity: 0.9; font-size: 14px;">
              {{ feedback.created_at | date: 'MMM dd, yyyy' }}<br />
              <span style="font-size: 12px; opacity: 0.7;">
                {{ feedback.created_at | date: 'HH:mm:ss' }}
              </span>
            </td>
            <td class="feedback-note">{{ feedback.note }}</td>
            <td>
              <div>{{ feedback.created_by?.name || feedback.user?.name || '—' }}</div>
              <span style="font-size: 12px; opacity: 0.7;">
                {{ feedback.created_by?.email || feedback.user?.email || '' }}
              </span>
            </td>
          </tr>
        </ng-container>
        <ng-template #noFeedback>
          <tr>
            <td colspan="3" class="no-transactions-message">
              {{ noFeedbackMessage }}
            </td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>

  <div *ngIf="showAddForm" class="form-container">
    <form (ngSubmit)="submitFeedback()" class="feedback-form">
      <label for="feedback-note" class="form-label">Your Feedback</label>
      <textarea
        id="feedback-note"
        name="note"
        [(ngModel)]="note"
        rows="6"
        class="feedback-textarea"
        placeholder="Share your experience, suggestions, or issues..."
      ></textarea>

      <div class="form-actions">
        <button
          type="button"
          class="action-button"
          (click)="cancelAddForm()"
          [disabled]="isSubmitting"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="filter-button submit-button"
          [disabled]="isSubmitting"
        >
          {{ isSubmitting ? 'Submitting...' : 'Submit Feedback' }}
        </button>
      </div>
    </form>
  </div>
</div>
